var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-350 -300 1700 1700",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.093000,-0.093000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4885.2,4994.8c-76.6-42.1-4578.4-2714.1-4645.4-2758.2C117.2,2158.2,100,2095,100,1748.6c0-304.3,1.9-310.1,47.9-356l45.9-47.9H5000h4806.2l45.9,47.9c45.9,45.9,47.9,51.7,47.9,356c0,377.1-13.4,409.6-206.7,528.3c-70.8,44-1131.2,675.7-2358.1,1403C4956,5094.3,5011.5,5063.7,4885.2,4994.8z M5191.4,3457.8c193.3-57.4,344.5-189.5,434.5-380.9c45.9-97.6,53.6-139.7,53.6-277.5c0-137.8-7.7-179.9-53.6-279.5c-68.9-147.4-199.1-277.5-348.4-346.4c-97.6-45.9-139.7-53.6-277.5-53.6c-137.8,0-179.9,7.7-277.5,53.6c-149.3,68.9-279.5,199.1-348.4,346.4c-45.9,99.5-53.6,141.6-53.6,279.5c0,137.8,7.7,179.9,53.6,277.5C4523.4,3394.7,4866,3555.4,5191.4,3457.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.7,684.3l-47.9-45.9v-1743.7V-2849l47.9-45.9l45.9-47.9h518.7h518.7l45.9,47.9l47.9,45.9v1743.7V638.4l-47.9,45.9l-45.9,47.9h-518.7h-518.7L1219.7,684.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3363.5,684.3l-47.9-45.9v-1743.7V-2849l47.9-45.9l45.9-47.9h518.7h518.7l45.9,47.9l47.9,45.9v1743.7V638.4l-47.9,45.9l-45.9,47.9h-518.7h-518.7L3363.5,684.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5507.2,684.3l-47.9-45.9v-1743.7V-2849l47.9-45.9l45.9-47.9h518.7h518.7l45.9,47.9l47.9,45.9v1743.7V638.4l-47.9,45.9l-45.9,47.9h-518.7h-518.7L5507.2,684.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7651,684.3l-47.9-45.9v-1743.7V-2849l47.9-45.9l45.9-47.9h518.7h518.7l45.9,47.9l47.9,45.9v1743.7V638.4l-47.9,45.9l-45.9,47.9h-518.7h-518.7L7651,684.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.9-3603.2l-47.9-45.9v-518.7v-518.7l47.9-45.9l45.9-47.9H5000h4806.2l45.9,47.9l47.9,45.9v518.7v518.7l-47.9,45.9l-45.9,47.9H5000H193.8L147.9-3603.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankFallback);
export default __webpack_public_path__ + "static/media/bank-fallback.d1ffeaf748ab11cdba9fe596c3917282.svg";
export { ForwardRef as ReactComponent };